// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vts-tooltip{position:relative}.vts-tooltip__content{position:absolute;inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,-100%)}.vts-tooltip__content[aria-hidden=true]{display:none}", ""]);
// Exports
module.exports = exports;
